/* Bed Choices — Bed Builder
 * Native Shopify variants + bundled add-on lines.
 * No jQuery, no third-party options app, no timers driving state.
 */
(function () {
  'use strict';

  var BUNDLE_ID = '_bc_bundle_id';
  var BUNDLE_ROLE = '_bc_bundle_role';

  function money(cents, format) {
    if (cents == null || isNaN(cents)) return '';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var joined = parts.join('.');
    var noDecimals = parts[0];

    return (format || '£{{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, joined)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, joined.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, joined);
  }

  function uid() {
    return 'bc-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function BedBuilder(root) {
    this.root = root;
    var node = root.querySelector('[data-bc-data]');
    if (!node) return;

    try {
      this.data = JSON.parse(node.textContent);
    } catch (e) {
      console.error('[bed-builder] bad data payload', e);
      return;
    }

    this.autoAdvance = root.dataset.autoAdvance === 'true';
    this.enforceOrder = root.dataset.enforceOrder === 'true';
    this.showDeltas = root.dataset.showDeltas === 'true';
    this.advanceDelay = parseInt(root.dataset.advanceDelay, 10);
    if (isNaN(this.advanceDelay)) this.advanceDelay = 300;
    this.themePriceSelector = root.dataset.themePriceSelector || '';

    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bc-tab]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-bc-panel]'));
    this.errorEl = root.querySelector('[data-bc-error]');
    this.submitEl = root.querySelector('[data-bc-submit]');
    this.qtyEl = root.querySelector('[data-bc-qty]');
    this.totalEl = root.querySelector('[data-bc-total]');
    this.upliftEl = root.querySelector('[data-bc-uplift]');
    this.upliftTemplate = root.dataset.upliftTemplate || '';
    this.priceInButton = root.dataset.priceInButton !== 'false';
    this.compareEl = root.querySelector('[data-bc-compare]');
    this.extras = Array.prototype.slice.call(root.querySelectorAll('[data-bc-extra]'));

    this.selection = {}; // option position -> value
    this.addons = {}; // role -> addon object or null
    this.props = {}; // property name -> displayed value
    this.touched = {}; // option position -> chosen by the customer?
    this.preselect = root.dataset.preselect === 'true';

    this.basePrice = null;
    for (var vi = 0; vi < this.data.variants.length; vi++) {
      var pv = this.data.variants[vi];
      if (this.basePrice === null || pv.price < this.basePrice) this.basePrice = pv.price;
    }

    this.seed();
    this.bind();
    this.render();
  }

  /* ---------- setup ---------- */

  BedBuilder.prototype.seed = function () {
    var self = this;
    var current = this.data.variants.filter(function (v) {
      return v.id === self.data.selectedVariantId;
    })[0];

    // Prefer ?variant=, then the Liquid-selected variant, then first available.
    var params = new URLSearchParams(window.location.search);
    var fromUrl = parseInt(params.get('variant'), 10);
    if (fromUrl) {
      var match = this.data.variants.filter(function (v) {
        return v.id === fromUrl;
      })[0];
      if (match) current = match;
    }
    if (!current) {
      current =
        this.data.variants.filter(function (v) {
          return v.available;
        })[0] || this.data.variants[0];
    }

    if (current) {
      this.data.options.forEach(function (opt, i) {
        self.selection[opt.position] = current.options[i];
      });
    }

    // Any addon group with a "no extra" tile starts on that tile.
    this.root.querySelectorAll('[data-bc-addon-group]').forEach(function (group) {
      var role = group.dataset.bcAddonGroup;
      var none = group.querySelector('[data-bc-addon][data-addon-id=""]');
      self.addons[role] = null;
      if (none) none.classList.add('is-selected');
    });

    // Extra dropdowns start empty, unless the browser restored a choice.
    this.extras.forEach(function (wrap) {
      var role = wrap.dataset.addonRole;
      var select = wrap.querySelector('[data-bc-extra-select]');
      self.addons[role] = select && select.value === 'yes' ? self.addonByRole(role) : null;
    });
  };

  BedBuilder.prototype.bind = function () {
    var self = this;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        self.openTab(tab.dataset.bcTab, true);
      });
    });

    this.root.querySelectorAll('[data-bc-value]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        if (tile.classList.contains('is-unavailable')) return;
        var pos = parseInt(tile.dataset.optionPosition, 10);
        self.selection[pos] = tile.dataset.value;
        self.touched[pos] = true;
        self.markComplete(tile);
        self.render();
        self.advance(tile);
      });
    });

    this.root.querySelectorAll('[data-bc-addon]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        if (tile.classList.contains('is-unavailable')) return;
        var role = tile.dataset.addonRole;
        var id = parseInt(tile.dataset.addonId, 10);
        self.addons[role] = isNaN(id)
          ? null
          : self.data.addons.filter(function (a) {
              return a.id === id;
            })[0] || null;
        self.markComplete(tile);
        self.render();
        self.advance(tile);
      });
    });

    this.root.querySelectorAll('[data-bc-fabric-range]').forEach(function (select) {
      select.addEventListener('change', function () {
        var wrap = select.closest('[data-bc-fabric]');
        var chosen = select.value;

        wrap.querySelectorAll('[data-bc-fabric-colours]').forEach(function (grid) {
          grid.hidden = grid.dataset.bcFabricColours !== chosen;
        });

        // Changing range invalidates the colour underneath it.
        wrap.querySelectorAll('[data-bc-fabric-colour]').forEach(function (t) {
          t.classList.remove('is-selected');
        });
        delete self.props[wrap.dataset.propertyName || 'Fabric'];
        self.render();
      });
    });

    this.root.querySelectorAll('[data-bc-fabric-colour]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        var wrap = tile.closest('[data-bc-fabric]');
        wrap.querySelectorAll('[data-bc-fabric-colour]').forEach(function (t) {
          t.classList.remove('is-selected');
        });
        tile.classList.add('is-selected');

        self.props[wrap.dataset.propertyName || 'Fabric'] =
          tile.dataset.range + ' – ' + tile.dataset.colour;

        self.markComplete(tile);
        self.render();
        self.advance(tile);
      });
    });

    this.root.querySelectorAll('[data-bc-choice]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        var group = tile.closest('[data-bc-choices]');
        var name = group.dataset.propertyName;

        group.querySelectorAll('[data-bc-choice]').forEach(function (t) {
          t.classList.remove('is-selected');
        });
        tile.classList.add('is-selected');

        self.props[name] = tile.dataset.choice;
        self.markComplete(tile);
        self.render();
        self.advance(tile);
      });
    });

    this.extras.forEach(function (wrap) {
      var select = wrap.querySelector('[data-bc-extra-select]');
      if (!select) return;
      select.addEventListener('change', function () {
        var role = wrap.dataset.addonRole;
        self.addons[role] = select.value === 'yes' ? self.addonByRole(role) : null;
        self.clearExtraError(wrap);
        self.render();
      });
    });

    if (this.qtyEl) {
      this.qtyEl.addEventListener('change', function () {
        self.render();
      });
    }

    if (this.submitEl) {
      this.submitEl.addEventListener('click', function () {
        self.submit();
      });
    }

    this.bindNativeForm();
  };

  /* ---------- variant maths ---------- */

  BedBuilder.prototype.variantFor = function (selection) {
    var self = this;
    return (
      this.data.variants.filter(function (v) {
        return self.data.options.every(function (opt, i) {
          return v.options[i] === selection[opt.position];
        });
      })[0] || null
    );
  };

  BedBuilder.prototype.currentVariant = function () {
    return this.variantFor(this.selection);
  };

  // Cheapest available variant that has `value` at `position`, other choices held where possible.
  BedBuilder.prototype.probe = function (position, value) {
    var self = this;
    var idx = this.data.options.findIndex(function (o) {
      return o.position === position;
    });
    if (idx < 0) return null;

    var candidates = this.data.variants.filter(function (v) {
      return v.options[idx] === value;
    });
    if (!candidates.length) return null;

    var exact = candidates.filter(function (v) {
      return self.data.options.every(function (opt, i) {
        return i === idx || v.options[i] === self.selection[opt.position];
      });
    });

    var pool = exact.length ? exact : candidates;
    var available = pool.filter(function (v) {
      return v.available;
    });
    var use = available.length ? available : pool;

    return use.reduce(function (min, v) {
      return !min || v.price < min.price ? v : min;
    }, null);
  };

  BedBuilder.prototype.addonByRole = function (role) {
    return (
      this.data.addons.filter(function (a) {
        return a.role === role;
      })[0] || null
    );
  };

  BedBuilder.prototype.addonVariant = function (addon) {
    if (!addon || !addon.variants.length) return null;
    if (addon.variants.length === 1) return addon.variants[0];

    // Match the add-on to a chosen option value (e.g. a mattress that follows Size).
    var wanted = addon.matchOption;
    var targets = [];
    if (wanted) {
      var opt = this.data.options.filter(function (o) {
        return o.name.toLowerCase() === wanted.toLowerCase();
      })[0];
      if (opt) targets.push(this.selection[opt.position]);
    } else {
      var self = this;
      this.data.options.forEach(function (o) {
        targets.push(self.selection[o.position]);
      });
    }

    var hit = addon.variants.filter(function (av) {
      return av.options.some(function (val) {
        return targets.indexOf(val) !== -1;
      });
    })[0];

    return hit || addon.variants[0];
  };

  BedBuilder.prototype.chosenAddons = function () {
    var self = this;
    return Object.keys(this.addons)
      .map(function (role) {
        var addon = self.addons[role];
        if (!addon) return null;
        var v = self.addonVariant(addon);
        return v ? { role: role, addon: addon, variant: v } : null;
      })
      .filter(Boolean);
  };

  /* ---------- rendering ---------- */

  BedBuilder.prototype.render = function () {
    var self = this;
    var variant = this.currentVariant();
    var format = this.data.moneyFormat;
    var base = variant ? variant.price : 0;

    // Tiles: availability + uplift.
    // Uplift is measured against the cheapest value WITHIN each option, not
    // against the current variant, so the figures stay put as choices change.
    var byPosition = {};
    this.root.querySelectorAll('[data-bc-value]').forEach(function (tile) {
      var pos = tile.dataset.optionPosition;
      if (!byPosition[pos]) byPosition[pos] = [];
      byPosition[pos].push(tile);
    });

    Object.keys(byPosition).forEach(function (posKey) {
      var pos = parseInt(posKey, 10);
      var entries = byPosition[posKey].map(function (tile) {
        return { tile: tile, probe: self.probe(pos, tile.dataset.value) };
      });

      var priced = entries.filter(function (e) {
        return e.probe && e.probe.available;
      });
      var baseline = null;
      priced.forEach(function (e) {
        if (baseline === null || e.probe.price < baseline) baseline = e.probe.price;
      });

      entries.forEach(function (e) {
        var tile = e.tile;
        var probe = e.probe;
        var deltaEl = tile.querySelector('[data-bc-delta]');
        var soldEl = tile.querySelector('[data-bc-soldout]');
        var imgEl = tile.querySelector('[data-bc-tile-image]');

        // Both sides must be real values - comparing undefined to undefined
        // would mark every tile as chosen.
        var chosen = self.selection[pos];
        var thisValue = tile.dataset.value;
        var showAsChosen =
          !!chosen &&
          !!thisValue &&
          chosen === thisValue &&
          (self.preselect || self.touched[pos] === true);
        tile.classList.toggle('is-selected', showAsChosen);

        var usable = probe && probe.available;
        tile.classList.toggle('is-unavailable', !usable);
        if (soldEl) soldEl.hidden = !!usable;

        if (imgEl && probe && probe.thumb && !imgEl.dataset.loaded) {
          imgEl.style.backgroundImage = 'url("' + probe.thumb + '")';
          imgEl.dataset.loaded = '1';
        }

        if (deltaEl) {
          if (self.showDeltas && probe && baseline !== null) {
            var diff = probe.price - baseline;
            deltaEl.textContent = diff > 0 ? '+' + money(diff, format) : '';
          } else {
            deltaEl.textContent = '';
          }
        }
      });
    });

    // Add-on tiles
    this.root.querySelectorAll('[data-bc-addon]').forEach(function (tile) {
      var role = tile.dataset.addonRole;
      var id = parseInt(tile.dataset.addonId, 10);
      var chosen = self.addons[role];
      var isNone = isNaN(id);
      tile.classList.toggle('is-selected', isNone ? !chosen : !!chosen && chosen.id === id);

      if (isNone) return;

      var addon = self.data.addons.filter(function (a) {
        return a.id === id;
      })[0];
      var av = self.addonVariant(addon);
      var priceEl = tile.querySelector('[data-bc-addon-price]');
      var soldEl = tile.querySelector('[data-bc-soldout]');

      var usable = av && av.available;
      tile.classList.toggle('is-unavailable', !usable);
      if (soldEl) soldEl.hidden = !!usable;
      if (priceEl) priceEl.textContent = av && av.price > 0 ? '+' + money(av.price, format) : '';
    });

    // Extra dropdowns: live price on the Yes option, disabled if unavailable.
    this.extras.forEach(function (wrap) {
      var role = wrap.dataset.addonRole;
      var select = wrap.querySelector('[data-bc-extra-select]');
      var yes = wrap.querySelector('[data-bc-extra-yes]');
      if (!yes) return;

      var av = self.addonVariant(self.addonByRole(role));
      var usable = !!(av && av.available);
      yes.disabled = !usable;
      yes.textContent =
        (yes.dataset.yesLabel || 'Yes') + (av && av.price > 0 ? ' (+' + money(av.price, format) + ')' : '');

      if (!usable && self.addons[role]) {
        self.addons[role] = null;
        if (select) select.value = '';
      }
    });

    // Tab captions + summary
    this.panels.forEach(function (panel) {
      var key = panel.dataset.bcPanel;
      var tab = self.root.querySelector('[data-bc-tab="' + key + '"]');
      var caption = '';

      if (panel.dataset.panelType === 'variant_option') {
        var name = (panel.dataset.optionName || '').toLowerCase();
        var opt = self.data.options.filter(function (o) {
          return o.name.toLowerCase() === name;
        })[0];
        if (opt && (self.preselect || self.touched[opt.position])) {
          caption = self.selection[opt.position] || '';
        }
      } else if (panel.dataset.panelType === 'addon_group') {
        var role = panel.dataset.addonRole;
        var picked = self.addons[role];
        if (picked) {
          caption = picked.title;
        } else {
          var none = panel.querySelector('[data-bc-addon][data-addon-id=""] .bc-tile__title');
          caption = none ? none.textContent.trim() : '';
        }
      } else if (panel.querySelector('[data-bc-fabric], [data-bc-choices]')) {
        var holder = panel.querySelector('[data-bc-fabric], [data-bc-choices]');
        caption = self.props[holder.dataset.propertyName] || '';
      } else {
        var current = panel.querySelector('[data-bc-sibling].is-selected .bc-tile__title');
        caption = current ? current.textContent.trim() : '';
      }

      if (tab) {
        var valueEl = tab.querySelector('[data-bc-tab-value]');
        if (valueEl) valueEl.textContent = caption;
      }
      var row = self.root.querySelector('[data-bc-summary-row="' + key + '"] [data-bc-summary-value]');
      if (row) row.textContent = caption || '—';
    });

    // Total
    var addonTotal = this.chosenAddons().reduce(function (sum, entry) {
      return sum + entry.variant.price;
    }, 0);
    var qty = Math.max(1, parseInt(this.qtyEl ? this.qtyEl.value : 1, 10) || 1);
    var unit = base + addonTotal;
    var total = unit * qty;

    if (this.totalEl) this.totalEl.textContent = money(total, format);

    if (this.compareEl) {
      var compare = variant && variant.compareAtPrice ? variant.compareAtPrice : 0;
      if (compare > base) {
        this.compareEl.textContent = money((compare + addonTotal) * qty, format);
        this.compareEl.hidden = false;
      } else {
        this.compareEl.hidden = true;
      }
    }

    // Submit state
    if (this.submitEl) {
      var ok = !!(variant && variant.available);
      this.submitEl.disabled = !ok;
      this.submitEl.classList.toggle('is-disabled', !ok);
    }

    this.syncUplift(unit);
    this.syncThemePrice(unit, variant, addonTotal);
    this.syncButtonPrice(unit);
    this.syncUrl(variant);
    this.syncGallery(variant);
    this.syncNativeForm(variant);
    this.syncInstalments(variant);
    this.syncMattressSize();
  };

  /* "Select Mattress & Save" drawer: show the mattresses for the chosen bed size.
     The drawer renders one group per size (.related_main_prod_cover, keyed by
     data-title, e.g. 5'0 Kingsize) and shows only the first until told otherwise. */
  function sizeKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/['"`\u2018\u2019\u201C\u201D\u2032\u2033]/g, '') // 5"0, 5'0 and 5’0 all match
      .replace(/\s+/g, ' ')
      .trim();
  }

  BedBuilder.prototype.syncMattressSize = function () {
    var sizeOption = this.data.options.filter(function (o) {
      return /^size$/i.test(o.name);
    })[0];
    if (!sizeOption) return;

    var chosen = this.selection[sizeOption.position];
    if (!chosen || chosen === this.mattressSize) return;

    var covers = Array.prototype.slice.call(document.querySelectorAll('.related_main_prod_cover'));
    if (!covers.length) return;

    var key = sizeKey(chosen);
    var match = covers.filter(function (cover) {
      return sizeKey(cover.getAttribute('data-title')) === key;
    })[0];
    if (!match) return; // no mattress for this size: leave the drawer as it is

    this.mattressSize = chosen;
    covers.forEach(function (cover) {
      cover.style.display = cover === match ? '' : 'none';
    });
  };

  /* "Selection will add £119.00 to the price" — measured from the cheapest variant. */
  BedBuilder.prototype.syncUplift = function (unit) {
    if (!this.upliftEl) return;

    var extra = unit - (this.basePrice || 0);
    if (extra <= 0 || !this.upliftTemplate) {
      this.upliftEl.hidden = true;
      this.upliftEl.textContent = '';
      return;
    }

    var amount = money(extra, this.data.moneyFormat);
    var parts = this.upliftTemplate.split('{amount}');
    this.upliftEl.textContent = '';

    var lead = document.createTextNode(parts[0] || '');
    var strong = document.createElement('strong');
    strong.className = 'bc-uplift__amount';
    strong.textContent = amount;
    var tail = document.createTextNode(parts[1] || '');

    this.upliftEl.appendChild(lead);
    this.upliftEl.appendChild(strong);
    this.upliftEl.appendChild(tail);
    this.upliftEl.hidden = false;
  };

  /* The real add to cart button. Add-on cards have their own [name="add"]
     buttons, so .product-form__submit is the reliable marker in this theme. */
  BedBuilder.prototype.addToCartButton = function () {
    if (this._button && document.contains(this._button)) return this._button;

    var candidates = document.querySelectorAll('.product-form__submit, [name="add"]');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.closest('[data-bc-builder]')) continue;
      // Skip the mattress / assembly cards, which have buttons of their own.
      if (el.closest('.product-grid-item, [data-bc-addon-card]')) continue;
      this._button = el;
      return el;
    }

    this._button = this.submitEl || null;
    return this._button;
  };

  /* Append the live price to the theme's add to cart button, without
     disturbing whatever markup the theme already has inside it. */
  BedBuilder.prototype.syncButtonPrice = function (unit) {
    if (!this.priceInButton) return;

    var button = this.addToCartButton();
    if (!button) return;

    var slot = button.querySelector('[data-bc-button-price]');
    if (!slot) {
      slot = document.createElement('span');
      slot.setAttribute('data-bc-button-price', '');
      slot.className = 'bc-button-price';
      button.appendChild(slot);
    }
    slot.textContent = ' - ' + money(unit, this.data.moneyFormat);
  };

  /* A variant option the customer hasn't chosen yet, if any. */
  BedBuilder.prototype.missingOption = function () {
    if (this.preselect) return null;

    var panels = this.root.querySelectorAll('[data-panel-type="variant_option"]');
    for (var i = 0; i < panels.length; i++) {
      var tile = panels[i].querySelector('[data-bc-value]');
      if (!tile) continue;

      var pos = parseInt(tile.dataset.optionPosition, 10);
      if (this.touched[pos]) continue;

      var tab = this.root.querySelector('[data-bc-tab="' + panels[i].dataset.bcPanel + '"]');
      var label = tab ? tab.querySelector('.bc-tab__label') : null;
      return {
        label: label ? label.textContent.trim().toLowerCase() : 'an option',
        panel: panels[i]
      };
    }
    return null;
  };

  /* First picker on the page with nothing chosen yet, if any. */
  BedBuilder.prototype.missingProperty = function () {
    var holders = this.root.querySelectorAll('[data-bc-fabric], [data-bc-choices]');
    for (var i = 0; i < holders.length; i++) {
      var name = holders[i].dataset.propertyName;
      if (holders[i].dataset.optional === 'true') continue;
      if (!this.props[name]) {
        return {
          label: (name || 'an option').toLowerCase(),
          panel: holders[i].closest('[data-bc-panel]')
        };
      }
    }
    return null;
  };

  /* A required extra dropdown still on "Please choose", if any. */
  BedBuilder.prototype.missingExtra = function () {
    for (var i = 0; i < this.extras.length; i++) {
      var wrap = this.extras[i];
      if (wrap.dataset.required !== 'true') continue;
      var select = wrap.querySelector('[data-bc-extra-select]');
      if (select && !select.value) {
        var label = wrap.dataset.label || 'this option';
        return {
          label: label.toLowerCase(),
          message: 'Please choose an option for ' + label + '.',
          extra: wrap,
          panel: null
        };
      }
    }
    return null;
  };

  BedBuilder.prototype.firstGap = function () {
    return this.missingOption() || this.missingProperty() || this.missingExtra();
  };

  /* Tell the customer what's missing. The tab opens first, because opening a
     tab clears the error line. */
  BedBuilder.prototype.reportGap = function (gap) {
    if (gap.extra) {
      this.clearError();
      this.flagExtra(gap.extra, gap.message);
      return;
    }
    if (gap.panel) this.openTab(gap.panel.dataset.bcPanel, true);
    this.showError(gap.message || 'Please choose ' + gap.label + ' before adding to your basket.');
  };

  BedBuilder.prototype.flagExtra = function (wrap, message) {
    var errorEl = wrap.querySelector('[data-bc-extra-error]');
    var select = wrap.querySelector('[data-bc-extra-select]');
    wrap.classList.add('is-invalid');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
    if (select) {
      select.setAttribute('aria-invalid', 'true');
      wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      select.focus({ preventScroll: true });
    }
  };

  BedBuilder.prototype.clearExtraError = function (wrap) {
    var errorEl = wrap.querySelector('[data-bc-extra-error]');
    var select = wrap.querySelector('[data-bc-extra-select]');
    wrap.classList.remove('is-invalid');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
    if (select) select.removeAttribute('aria-invalid');
  };

  /* Mirror the running total into the theme's price markup, so the price at the
     top of the page follows the configurator including any add-ons. */
  BedBuilder.prototype.syncThemePrice = function (total, variant, addonTotal) {
    if (!this.themePriceSelector) return;

    var format = this.data.moneyFormat;
    var nodes = document.querySelectorAll(this.themePriceSelector);
    var self = this;

    nodes.forEach(function (el) {
      if (el.closest('[data-bc-builder]')) return; // never our own markup
      el.textContent = money(total, format);
    });

    if (!variant) return;

    var compare = variant.compareAtPrice || 0;
    if (compare > variant.price) {
      var wasNodes = document.querySelectorAll(
        '.price__sale .price-item--regular, .price-item--regular s, s.price-item'
      );
      wasNodes.forEach(function (el) {
        if (el.closest('[data-bc-builder]')) return;
        el.textContent = money(compare + addonTotal, format);
      });
    }
  };

  /* The theme's own product form, if the merchant is using its buy buttons. */
  BedBuilder.prototype.nativeForm = function () {
    var button = this.addToCartButton();
    if (button && button !== this.submitEl) {
      var owner = button.closest('form[action*="/cart/add"]') || button.closest('form');
      if (owner) return owner;
    }

    // Otherwise match a form by the variant it holds - the page also carries
    // add-on forms for the mattress and assembly cards.
    var ourIds = {};
    this.data.variants.forEach(function (v) {
      ourIds[String(v.id)] = true;
    });

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest('[data-bc-builder]')) continue;
      var idField = forms[i].querySelector('[name="id"]');
      if (idField && ourIds[String(idField.value)]) return forms[i];
    }
    return null;
  };

  /* Keep the theme's hidden variant input in step with the tiles. */
  BedBuilder.prototype.syncNativeForm = function (variant) {
    if (!variant) return;
    var form = this.nativeForm();
    if (!form) return;

    var input = form.querySelector('[name="id"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      form.appendChild(input);
    }
    if (String(input.value) !== String(variant.id)) {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var submit =
      form.querySelector('.product-form__submit') ||
      form.querySelector('[name="add"]') ||
      form.querySelector('[type="submit"]');
    if (submit) {
      submit.disabled = !variant.available;
      submit.classList.toggle('disabled', !variant.available);
    }

    this.syncNativeProperties(form);
  };

  /* The "Pay in 3" widget sits in its own form in the price block. Point it at
     the current bed variant so its figure follows Size / Headboard / Storage.
     It reads the bed only: add-ons are separate products. */
  BedBuilder.prototype.syncInstalments = function (variant) {
    if (!variant) return;
    document.querySelectorAll('form[id^="product-form-installment"] [name="id"]').forEach(function (input) {
      if (String(input.value) === String(variant.id)) return;
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  /* Line item properties the theme's own form would otherwise know nothing about. */
  BedBuilder.prototype.syncNativeProperties = function (form) {
    var existing = form.querySelectorAll('[data-bc-property]');
    for (var i = 0; i < existing.length; i++) existing[i].remove();

    var self = this;
    Object.keys(this.props).forEach(function (name) {
      var field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'properties[' + name + ']';
      field.value = self.props[name];
      field.setAttribute('data-bc-property', '');
      form.appendChild(field);
    });
  };

  /* If add-ons are selected, the native form can't post them - take over. */
  BedBuilder.prototype.bindNativeForm = function () {
    var self = this;
    var form = this.nativeForm();
    if (!form || form.dataset.bcBound) return;
    form.dataset.bcBound = '1';

    // Themes that add to cart over AJAX handle the click and never fire a
    // real submit event, so guard the button directly as well.
    var button = this.addToCartButton();
    if (button && !button.dataset.bcGuarded) {
      button.dataset.bcGuarded = '1';
      button.addEventListener(
        'click',
        function (e) {
          var gap = self.firstGap();
          if (gap) {
            e.preventDefault();
            e.stopImmediatePropagation();
            self.reportGap(gap);
            return;
          }

          // Properties and add-ons can't ride along on a theme AJAX request we
          // don't control, so post the whole line ourselves.
          var carries =
            Object.keys(self.props).length > 0 || self.chosenAddons().length > 0;
          if (!carries) return;

          e.preventDefault();
          e.stopImmediatePropagation();

          var qtyField = form ? form.querySelector('[name="quantity"]') : null;
          var qty = Math.max(1, parseInt(qtyField ? qtyField.value : 1, 10) || 1);
          self.submit(qty);
        },
        true
      );
    }

    form.addEventListener(
      'submit',
      function (e) {
        // Every picker on the page needs a choice before checkout.
        var missing = self.firstGap();
        if (missing) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.reportGap(missing);
          return;
        }

        var extras = self.chosenAddons();
        if (!extras.length) return; // properties ride along on the hidden inputs

        e.preventDefault();
        e.stopImmediatePropagation();

        var qtyField = form.querySelector('[name="quantity"]');
        var qty = Math.max(1, parseInt(qtyField ? qtyField.value : 1, 10) || 1);
        self.submit(qty);
      },
      true
    );
  };

  BedBuilder.prototype.syncUrl = function (variant) {
    if (!variant || !window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  BedBuilder.prototype.syncGallery = function (variant) {
    if (!variant || !variant.featuredImage) return;
    document.dispatchEvent(
      new CustomEvent('bc:variant:change', {
        detail: { variant: variant, productId: this.data.productId }
      })
    );
  };

  /* ---------- tabs ---------- */

  BedBuilder.prototype.markComplete = function (tile) {
    var panel = tile.closest('[data-bc-panel]');
    if (!panel) return;
    var tab = this.root.querySelector('[data-bc-tab="' + panel.dataset.bcPanel + '"]');
    if (tab) tab.classList.add('is-complete');
  };

  BedBuilder.prototype.openTab = function (key, userInitiated) {
    var self = this;
    var target = this.tabs.filter(function (t) {
      return t.dataset.bcTab === key;
    })[0];
    if (!target) return;

    if (userInitiated && this.enforceOrder) {
      var index = parseInt(target.dataset.tabIndex, 10);
      var previous = this.tabs[index - 1];
      if (previous && !previous.classList.contains('is-complete')) {
        var label = previous.querySelector('.bc-tab__label');
        this.showError('Choose ' + (label ? label.textContent.trim() : 'the previous option') + ' first.');
        return;
      }
    }

    this.clearError();

    this.tabs.forEach(function (tab) {
      var on = tab === target;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    this.panels.forEach(function (panel) {
      var on = panel.dataset.bcPanel === key;
      panel.classList.toggle('is-active', on);
      panel.hidden = !on;
    });

    if (userInitiated) {
      target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  };

  BedBuilder.prototype.advance = function (tile) {
    if (!this.autoAdvance) return;
    var panel = tile.closest('[data-bc-panel]');
    if (!panel) return;
    var tab = this.root.querySelector('[data-bc-tab="' + panel.dataset.bcPanel + '"]');
    if (!tab) return;
    var next = this.tabs[parseInt(tab.dataset.tabIndex, 10) + 1];
    if (!next) return;

    var self = this;
    clearTimeout(this.advanceTimer);

    if (this.advanceDelay <= 0) {
      this.openTab(next.dataset.bcTab, false);
      return;
    }

    // Let the tick register on the tile the customer just pressed, then move on.
    this.advanceTimer = setTimeout(function () {
      self.openTab(next.dataset.bcTab, false);
    }, this.advanceDelay);
  };

  /* ---------- feedback ---------- */

  BedBuilder.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  };

  BedBuilder.prototype.clearError = function () {
    if (!this.errorEl) return;
    this.errorEl.textContent = '';
    this.errorEl.hidden = true;
  };

  /* ---------- add to cart ---------- */

  BedBuilder.prototype.submit = function (forcedQty) {
    var self = this;
    var variant = this.currentVariant();

    if (!variant) {
      this.showError('That combination is not available. Try a different choice.');
      return;
    }
    if (!variant.available) {
      this.showError('That combination is out of stock.');
      return;
    }
    var missing = this.firstGap();
    if (missing) {
      this.reportGap(missing);
      return;
    }

    var qty = forcedQty || Math.max(1, parseInt(this.qtyEl ? this.qtyEl.value : 1, 10) || 1);
    var bundleId = uid();

    var items = [
      {
        id: variant.id,
        quantity: qty,
        properties: (function () {
          var p = {};
          if (self.chosenAddons().length) {
            p[BUNDLE_ID] = bundleId;
            p[BUNDLE_ROLE] = 'parent';
          }
          Object.keys(self.props).forEach(function (name) {
            p[name] = self.props[name];
          });
          return p;
        })()
      }
    ];

    this.chosenAddons().forEach(function (entry) {
      var props = {};
      props[BUNDLE_ID] = bundleId;
      props[BUNDLE_ROLE] = entry.role;
      // Visible in the cart, checkout and order, so it's clear which bed it's for.
      if (entry.addon.forLabel) {
        props[entry.addon.forLabel] =
          self.data.productTitle +
          (variant.title && variant.title !== 'Default Title' ? ' – ' + variant.title : '');
      }
      items.push({ id: entry.variant.id, quantity: qty, properties: props });
    });

    this.setBusy(true);
    this.clearError();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      // Shopify puts each added item at the top of the cart, so send the add-ons
      // first and the bed last: the bed then sits above its add-ons in the cart,
      // checkout and order.
      body: JSON.stringify({ items: items.slice().reverse() })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'Could not add to basket.');
          return body;
        });
      })
      .then(function () {
        self.setBusy(false);
        self.afterAdd();
      })
      .catch(function (err) {
        self.setBusy(false);
        self.showError(err.message);
      });
  };

  BedBuilder.prototype.setBusy = function (busy) {
    if (!this.submitEl) return;
    this.submitEl.classList.toggle('is-busy', busy);
    this.submitEl.disabled = busy;
    var spinner = this.submitEl.querySelector('.bc-submit__spinner');
    if (spinner) spinner.hidden = !busy;
  };

  BedBuilder.prototype.afterAdd = function () {
    var mode = this.data.cartRedirect;

    document.dispatchEvent(new CustomEvent('bc:cart:updated'));

    if (mode === 'cart') {
      window.location.href = '/cart';
      return;
    }

    if (mode === 'drawer') {
      var drawer =
        document.querySelector('cart-drawer') ||
        document.querySelector('#CartDrawer') ||
        document.querySelector('.cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      var trigger = document.querySelector('[data-open-cart-drawer], .cart-icon-bubble, #cart-icon-bubble');
      if (trigger) {
        trigger.click();
        return;
      }
      window.location.href = '/cart';
      return;
    }

    // stay
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  };

  /* ---------- add-on card placement ----------
     The legacy castle script relocates .add-ons-container after the Klarna
     row on mobile, which lands it above the builder. Put it back underneath.
     Harmless once that script is retired: it simply finds nothing to move. */

  function placeAddOns() {
    var cards = document.querySelector('.add-ons-container');
    var builder = document.querySelector('[data-bc-builder]');
    if (!cards || !builder) return;
    if (window.innerWidth > 768) return; // desktop placement is fine
    if (cards.previousElementSibling === builder) return; // already right

    builder.parentNode.insertBefore(cards, builder.nextSibling);
  }

  function watchAddOns() {
    placeAddOns();

    var host = document.querySelector('.product__info-container');
    if (host && 'MutationObserver' in window) {
      var pending;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(placeAddOns, 50);
      }).observe(host, { childList: true });
    }

    // Width changes only: mobile toolbars fire resize with a new height while
    // scrolling, and moving the cards then made the page jump.
    var resizeTimer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(placeAddOns, 350); // after the legacy script
    });
  }

  /* ---------- boot ---------- */

  function init() {
    document.querySelectorAll('[data-bc-builder]').forEach(function (root) {
      if (root.dataset.bcReady) return;
      root.dataset.bcReady = '1';
      new BedBuilder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      watchAddOns();
    });
  } else {
    init();
    watchAddOns();
  }

  // Theme editor re-renders
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-bc-builder]');
    if (!root) return;
    var tab = e.target.dataset ? e.target.dataset.bcTab : null;
    if (tab) {
      var el = root.querySelector('[data-bc-tab="' + tab + '"]');
      if (el) el.click();
    }
  });
})();